import DetailReducer from '../detail/DetailReducer';
import SharedReducer from '../shared/SharedReducer';

export default function BaseReducer() {
    return {
        shared: SharedReducer(), // Shared reducer, který používají některé fieldy v shared - auto konfigurace store
        authInfo: DetailReducer(),   // informace o uživateli a jeho přihlášení
    };
}
